export const primaryButton = {
    marginTop: "5px",
    marginBottom: "5px",
    fontWeight: "700",
    fontSize: "15px",
    p: "11px 0px",
};
export const secondaryButton = {
    marginTop: "5px",
    fontWeight: "600",
    fontSize: "15px",
    p: "8px 0px",
    color: "black",
    border: "1px solid rgba(200, 200, 200, 1)",
    "&:hover": {
        background: "none",
        border: "1px solid rgba(227, 227, 228, 1)",
    },
};

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 200,
            width: 250,
            borderRadius: 5,
            border: "1px solid #00000033",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        },
    },
};
export const itemStyle = {
    fontSize: "2px",
    padding: "0px",
    margin: 0,
};

export const FormHelperTextFieldStyle = {
    fontSize: "10px",
};
